import React from 'react';
import { Select, Option } from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

export const SeleccionadorX = ({ 
    vector, 
    onchange, 
    valor, 
    nombre, 
    noDefault, 
    limpiar, 
    claves, 
    disabled,
    extracss,
    name: propName 
}) => {
    if (!vector || !vector?.length) return null;

    const handleInternalChange = (val) => {
        if (onchange) {
            onchange({
                target: {
                    value: val,
                    name: propName || ''
                }
            });
        }
    };

    const opciones = [];

    // 1. Agregamos la opción por defecto si corresponde
    if (!noDefault) {
        opciones.push(
            <Option key="default-opt" value="-1">
                {nombre}
            </Option>
        );
    }

    // 2. Agregamos las opciones del vector
    vector.forEach((item, index) => {
        const id = claves ? item[claves.id] : item;
        const labelText = claves ? item[claves.nombre] : item;
        
        // Solo agregamos si el ID es válido
        if (id !== undefined && id !== null) {
            opciones.push(
                <Option key={index} value={String(id)}>
                    {labelText}
                </Option>
            );
        }
    });

    return (
        <div className={`flex items-center gap-2 w-full ${extracss}`}>
            <div className="w-full">
                <Select
                    label={nombre}
                    // Aseguramos que el valor sea siempre un string para evitar conflictos
                    value={valor !== undefined && valor !== null ? String(valor) : "-1"}
                    onChange={handleInternalChange}
                    disabled={disabled}
                    className="focus:!border-blue-500 focus:!border-t-transparent focus:!border-2 transition-all"
                    labelProps={{
                        className: "peer-focus:text-blue-500",
                    }}
                >
                    {/* Renderizamos solo el array de componentes válidos */}
                    {opciones}
                </Select>
            </div>

            {valor !== "-1" && valor !== "*" && limpiar && (
                <button
                    type="button"
                    onClick={limpiar}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                >
                    <FontAwesomeIcon icon={faWindowClose} size="lg" />
                </button>
            )}
        </div>
    );
};